import { normalizeStrokeWidth } from './utils/normalizeStrokeWidth.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from '../utils/style.svg.js';

const PM2BuildingIcon = ({
  color = "currentColor",
  strokeWidth = 1.5,
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    ...svgProps,
    viewBox: "0 0 25 22.372",
    fill: "none",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: normalizeStrokeWidth(strokeWidth, 22.372),
    children: [/*#__PURE__*/jsx("path", {
      d: "m24.216 8.243v1.792a.689.689 0 0 1 -.575.228h-22.186a.689.689 0 0 1 -.575-.228v-1.824"
    }), /*#__PURE__*/jsx("path", {
      d: "m.88 21.72a.609.609 0 0 1 .575-.341h22.186a.609.609 0 0 1 .575.341"
    }), /*#__PURE__*/jsx("path", {
      d: "m24.5 7.67h-24"
    }), /*#__PURE__*/jsx("path", {
      d: "m22.615 5.508v1.792a.553.553 0 0 1 -.492.228h-18.994a.553.553 0 0 1 -.492-.228v-1.824"
    }), /*#__PURE__*/jsx("path", {
      d: "m8.673 4.935h-6.292"
    }), /*#__PURE__*/jsx("path", {
      d: "m22.948 4.935h-6.292"
    }), /*#__PURE__*/jsx("path", {
      d: "m12.723 1.423v-.923"
    }), /*#__PURE__*/jsx("path", {
      d: "m13.693 3.496v-1.674c0-.185-.223-.335-.5-.335h-1c-.275 0-.5.15-.5.335v1.674"
    }), /*#__PURE__*/jsx("path", {
      d: "m16.578 7.157v-3.3c0-.166-.249-.3-.556-.3h-6.675c-.307 0-.556.134-.556.3v3.3"
    }), /*#__PURE__*/jsx("path", {
      d: "m1.898 10.32v10.97"
    }), /*#__PURE__*/jsx("path", {
      d: "m2.411 10.32v10.97"
    }), /*#__PURE__*/jsx("path", {
      d: "m5.488 10.32v10.97"
    }), /*#__PURE__*/jsx("path", {
      d: "m6.001 10.32v10.97"
    }), /*#__PURE__*/jsx("path", {
      d: "m9.078 10.32v10.97"
    }), /*#__PURE__*/jsx("path", {
      d: "m9.591 10.32v10.97"
    }), /*#__PURE__*/jsx("path", {
      d: "m15.575 10.32v10.97"
    }), /*#__PURE__*/jsx("path", {
      d: "m16.088 10.32v10.97"
    }), /*#__PURE__*/jsx("path", {
      d: "m19.165 10.32v10.97"
    }), /*#__PURE__*/jsx("path", {
      d: "m19.678 10.32v10.97"
    }), /*#__PURE__*/jsx("path", {
      d: "m22.755 10.32v10.97"
    }), /*#__PURE__*/jsx("path", {
      d: "m23.268 10.32v10.97"
    })]
  });
};

export { PM2BuildingIcon };
//# sourceMappingURL=building.js.map
